import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { getToken, removeToken } from '../utils/auth';

function Navbar() {
  const [isAuth, setIsAuth] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsAuth(!!getToken());
  }, []);

  const handleLogout = () => {
    removeToken();
    setIsAuth(false);
    navigate('/');
  };

  return (
    <header className="fe-navbar">
      {/* Mobile-only brand shown above the navbar on small screens */}
      <div className="fe-navbar__mobile-brand">
        <Link to="/" className="fe-navbar__brand-link">Florida Elections</Link>
      </div>
      <div className="fe-navbar__container">
        <div className="fe-navbar__brand">
          <Link to="/" className="fe-navbar__brand-link">Florida Elections</Link>
        </div>

        <nav className="fe-navbar__nav">
          <Link to="/" className="fe-navbar__item">Home</Link>
          <Link to="/candidates" className="fe-navbar__item">Candidates</Link>
          <Link to="/committees" className="fe-navbar__item">Committees</Link>
          <Link to="/documents/recent" className="fe-navbar__item">Docs</Link>
            <a href="/candidates_sitemap.html" className="fe-navbar__item">Site Map</a>
          {isAuth ? (
            <>
              <Link to="/admin" className="fe-navbar__item">Admin</Link>
              <button onClick={handleLogout} className="fe-navbar__item" style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }}>Log Out</button>
            </>
          ) : (
            <Link to="/admin/login" className="fe-navbar__item">Admin</Link>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
